import Navbar from '@/components/feature/Navbar';
import ContactFooter from '@/pages/home/components/ContactFooter';
import EssentialHero from './components/EssentialHero';
import EssentialItems from './components/EssentialItems';
import EssentialNotice from './components/EssentialNotice';

export default function EssentialPage() {
  return (
    <div className="min-h-screen w-full">
      <Navbar />
      <main>
        <EssentialHero />
        <EssentialItems />
        <EssentialNotice />
      </main>
      <ContactFooter />
    </div>
  );
}
